export const navItems = [
    {id:'recent-work',  title: 'Recent work'},
    {id:'experience', title: 'Experience'},
    {id:'about-me', title: 'About me'}
];

export const work = [
    {  
        id: 'dj-habibeats',
        title: 'DJ Habibeats',
        desc: 'Designed and built a custom WordPress theme used for managing a single-page website aimed at promoting DJ Habibeats’ music, tour dates and merch sales.',
        year: '2023',
        categories: ['marketing', 'wordpress', 'freelance'],
        url: 'https://djhabibeats.com'
    },
    {  
        id: 'sabrina-claudio',
        title: 'Sabrina Claudio',
        desc: 'Designed and built a custom WordPress theme used for managing a single-page website aimed at promoting Grammy-nominated singer/songwriter, Sabrina Claudio’s music, tour dates and merch sales.',
        year: '2023',
        categories: ['marketing', 'wordpress', 'freelance'],
        url: 'https://sabrinaclaudio.co'
    },
    {  
        id: 'heavy',
        title: 'Heavy',
        desc: 'Built a custom theme for a multidisciplinary creative agency based in Philadelphia. The theme consists of flexible components used to build bespoke page layouts.',
        year: '2021',
        categories: ['marketing', 'wordpress', 'freelance'],
        url: 'https://heavydoesit.com'
    },
    {
        id: 'whyy',
        title: 'WHYY',
        desc: 'Worked closely with team leads and stakeholders to consolidate, organize  & migrate existing content, build & deliver a new custom theme and implement new features including a persistent audio player for radio content.',
        year: '2017',
        categories: ['marketing', 'wordpress', 'bluecadet'],
        url: 'https://whyy.org/'
    }
];

export const places = [
    {
        id:'cvs-health',
        title: 'CVS Health - Design Systems Engineer',
        tags: ['Typescript', 'Lit', 'Storybook', 'Figma', 'Web Components', 'Health Tech'],
        year: '2025 - Present',
    },
    {
        id:'comcast',
        title: 'Comcast - UX Engineer',
        tags: ['React JS', 'ES6', 'Typescript', 'VueJS', 'Figma', 'Internal tools'],
        year: '2020 - 2024',
    },
    {
        id:'fast-capital-360',
        title: 'Fast Capital 360 - Lead Developer',
        tags: ['HTML', 'SCSS', 'JS', 'jQuery', 'WordPress'],
        year: '2018 - 2019',
    },
    {
        id:'bluecadet',
        title: 'Bluecadet - Web Developer',
        tags: ['HTML', 'SCSS', 'JS', 'jQuery', 'PHP', 'WordPress', 'Drupal 8'],
        year: '2017 - 2018',
    },
    {
        id:'cohere',
        title: 'Cohere - Web Developer',
        tags: ['HTML', 'SCSS', 'JS', 'jQuery', 'WordPress', 'UI', 'UX'],
        year: '2014 - 2017',
    },

];

export const links = [
    {
        title: 'email',
        href: 'mailto:iamtylerjordan@gmail.com'
    },
    {
        title: 'instagram',
        href: 'https://www.instagram.com/iamtylerjordan/'
    },
    {
        title: 'codepen',
        href: 'https://codepen.io/tylerjordan'
    },
    {
        title: 'github',
        href: 'https://github.com/tylerjordanp724'
    }
];